import React from 'react';
import PropTypes from 'prop-types';
import getCustomIcon from 'lib/seats/getCustomIcon';

const KeyIcon = props => {
  const seatType = props.seatType;
  if (seatType.method === 'custom') {
    const icon = getCustomIcon(seatType.customName);
    return icon ? (
      <svg
        className="syos-custom-icon"
        viewBox={`0 0 ${props.customIconSize} ${props.customIconSize}`}
      >
        <path className={`seat seat--${seatType.slug}`} d={icon.pathData} />
      </svg>
    ) : null;
  } else {
    const defaultKeySize = 18;
    return (
      <svg viewBox={`0 0 ${defaultKeySize} ${defaultKeySize}`}>
        <circle
          className={`seat seat--${seatType.slug}`}
          r={defaultKeySize / 3}
          cx={defaultKeySize / 2}
          cy={defaultKeySize / 2}
        />
      </svg>
    );
  }
};
KeyIcon.propTypes = {
  customIconSize: PropTypes.number,
  seatType: PropTypes.shape({
    method: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired
  })
};

export default KeyIcon;



// WEBPACK FOOTER //
// ./src/javascripts/components/KeyIcon.js